import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/out-in-stock-record/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/out-in-stock-record/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/out-in-stock-record/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/out-in-stock-record/select/page',
        method: 'get',
        params
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/out-in-stock-record/inbound/export',
        method: 'get',
        params,
        responseType: 'blob'
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/out-in-stock-record/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}

export const getMonthList = (params) => {
    return request({
        url: '/api/produce/transport-plan/select/page',
        method: 'get',
        params
    })
}

export const submit = (row) => {
  return request({
    url: '/api/produce/out-in-stock-record/insert',
    method: 'post',
    data: row
  })
}

export const getInfo = (id) => {
  return request({
    url: '/api/produce/out-in-stock-record/select/id',
    method: 'get',
    params: {
      id
    }
  })
}
